module.exports = __webpack_public_path__ + "media/images/application/template/logos/sagepay-logo-e95afbab3862b8045e136111cec9a449.png";